import React, { useEffect, useState } from "react";
import { getPlansForCro } from "../api/api";
import { useSearchParams } from "react-router-dom";
import { PlanType, UtilityType } from "../types/planType";
import { injectIsFeaturedPlans } from "../utils/injectIsFeaturedPlans";
import PlanCardSummary from "../cro/PlanCardSummary";
import PlanCardSkeleton from "../cro/PlanCardSkeleton";
import { getEnrollmentRecord } from "../api/enrollment";
import PlanSummaryCard from "./cards/PlanSummaryCard";
import { injectCustomDescription } from "../utils/injectCustomDescription";

interface PlanSummaryV2Props {
  selectedPlans?: any[];
  handleSwitchCommodity: Function;
  handleShowPlanModal: Function;
}

const PlanSummaryV2 = ({
  selectedPlans,
  handleSwitchCommodity,
  handleShowPlanModal,
}: PlanSummaryV2Props) => {
  const [searchParams] = useSearchParams();

  const [cardLoading, setCardLoading] = React.useState(false);
  const [cardLoading2, setCardLoading2] = React.useState(false);

  const [plan, setPlan] = React.useState<PlanType | null>(null);
  const [utility, setUtility] = React.useState<any>({});

  const [plan2, setPlan2] = React.useState<PlanType | null>(null);
  const [utility2, setUtility2] = React.useState<any>({});

  // for the first plan
  const utilityId = selectedPlans && selectedPlans[0]?.id_utility;
  const plan_id = selectedPlans && selectedPlans[0]?.plan_id;
  const utilityName = (utility as UtilityType)?.name || "";
  const isTx = (utility as UtilityType)?.markets?.state_code === "TX";
  const stateCode = (utility as UtilityType)?.markets?.state_code || "";

  // for the second plan
  const utilityId2 = selectedPlans && selectedPlans[1]?.id_utility;
  const plan_id2 = selectedPlans && selectedPlans[1]?.plan_id;
  const utilityName2 = (utility2 as UtilityType)?.name || "";
  const isTx2 = (utility2 as UtilityType)?.markets?.state_code === "TX";
  const stateCode2 = (utility2 as UtilityType)?.markets?.state_code || "";

  const promocode =
    searchParams.get("promocode") ||
    searchParams.get("promoCode") ||
    searchParams.get("promo_code");

  const selectedLanguage = localStorage.getItem("lang") || "en";

  const url = new URL(window.location.href);
  const idParam = url.searchParams.get("id");
  const signParam = url.searchParams.get("sign");

  const [userData, setUserData] = useState<any>(null);

  useEffect(() => {
    if (!idParam || !signParam) return;
    const getUserData = async () => {
      const response = await getEnrollmentRecord(idParam, signParam);
      setUserData(response?.data?.record || null);
    };

    getUserData();
  }, [idParam, signParam]);

  useEffect(() => {
    if (!utilityId) return;
    (async () => {
      setCardLoading(true);
      const response = await getPlansForCro({
        utility_id: utilityId,
        promocode,
        language: selectedLanguage,
      });
      if (response.status === 200) {
        const injectIsFeatured = await injectIsFeaturedPlans(
          response.data?.plans as PlanType[],
          utilityId
        );
        const injectCustomDescriptions = await injectCustomDescription(
          (injectIsFeatured || []) as PlanType[],
          stateCode
        );

        const findCurrentPlan = injectCustomDescriptions.find(
          (plan: any) => "plan_id" in plan && plan.plan_id === plan_id
        );

        if (findCurrentPlan) {
          setPlan(findCurrentPlan as PlanType);
        }
        setCardLoading(false);
        setUtility(response.data.utilities[utilityId] || {});
      } else {
        console.error("Error fetching plans:", response.statusText);
        setCardLoading(false);
      }
    })();
  }, [utilityId, promocode, plan_id, selectedLanguage, stateCode]);

  useEffect(() => {
    if (!utilityId2) return;
    (async () => {
      setCardLoading2(true);
      const response = await getPlansForCro({
        utility_id: utilityId2,
        promocode,
        language: selectedLanguage,
      });
      if (response.status === 200) {
        const injectIsFeatured = await injectIsFeaturedPlans(
          response.data?.plans as PlanType[],
          utilityId2
        );
        const injectCustomDescriptions = await injectCustomDescription(
          (injectIsFeatured || []) as PlanType[],
          stateCode
        );
        const findCurrentPlan = injectCustomDescriptions.find(
          (plan: any) => "plan_id" in plan && plan.plan_id === plan_id2
        );

        if (findCurrentPlan) {
          setPlan2(findCurrentPlan as PlanType);
        }
        setCardLoading2(false);
        setUtility2(response.data.utilities[utilityId2] || {});
      } else {
        console.error("Error fetching plans:", response.statusText);
        setCardLoading2(false);
      }
    })();
  }, [utilityId2, promocode, plan_id2, selectedLanguage, stateCode]);

  if (cardLoading || cardLoading2) return <PlanCardSkeleton />;

  if (userData?.plan) {
    return (
      <PlanSummaryCard
        selectedPlan={userData?.plan && JSON.parse(userData?.plan)}
        promocode={userData?.promo_code || ""}
      />
    );
  }

  return (
    <div>
      {!plan ? null : (
        <PlanCardSummary
          isFeatured={plan?.isFeatured}
          utilityName={utilityName}
          utilityId={utilityId}
          plan={plan}
          isTypeVariable={
            stateCode === "PA" && plan.plan_name.includes("Embrace Green 3")
          }
          isTx={isTx}
          handleSwitchCommodity={handleSwitchCommodity}
          handleShowPlanModal={handleShowPlanModal}
        />
      )}
      {!plan2 ? null : (
        <PlanCardSummary
          isFeatured={plan2?.isFeatured}
          utilityName={utilityName2}
          utilityId={utilityId2}
          plan={plan2}
          isTypeVariable={
            stateCode2 === "PA" && plan2.plan_name.includes("Embrace Green 3")
          }
          isTx={isTx2}
          handleSwitchCommodity={handleSwitchCommodity}
          handleShowPlanModal={handleShowPlanModal}
        />
      )}
    </div>
  );
};

export default PlanSummaryV2;
